import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, X } from 'lucide-react';

interface CompanyDeleteModalProps {
  companyName?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const CompanyDeleteModal: React.FC<CompanyDeleteModalProps> = ({ companyName, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-red-600 dark:text-red-400 flex items-center">
            <AlertTriangle className="mr-2" size={20} />
            {t('company.delete.title', 'Supprimer l\'entreprise')}
          </h3>
          <button 
            onClick={onCancel}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="space-y-4">
          <p className="text-gray-700 dark:text-gray-300">
            {t('company.delete.confirmation', 'Êtes-vous sûr de vouloir supprimer l\'entreprise')} <strong>{companyName}</strong>?
          </p>
          
          <p className="text-gray-700 dark:text-gray-300">
            {t('company.delete.warning', 'Cette action est irréversible. Toutes les données associées à cette entreprise seront définitivement supprimées.')}
          </p>
          
          <div className="bg-yellow-50 dark:bg-yellow-900/30 border-l-4 border-yellow-400 p-4 mt-4">
            <div className="flex">
              <div className="ml-3">
                <p className="text-sm text-yellow-700 dark:text-yellow-400">
                  {t('company.delete.dataWarning', 'Cette action supprimera également toutes les données associées, y compris les services, les réservations et les collaborateurs.')}
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              {t('company.delete.cancel', 'Annuler')}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            >
              {t('company.delete.confirm', 'Supprimer définitivement')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDeleteModal;
